import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BasysArenaComponent } from './basys-arena.component';
import { AbcArenaModule } from '@barthauer/abc/arena';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BasysCoreAuthenticationModule } from '@barthauer/basys/core/authentication';

@NgModule({
    imports: [CommonModule, RouterModule, FormsModule, AbcArenaModule, BasysCoreAuthenticationModule, BrowserModule],
    declarations: [BasysArenaComponent],
    exports: [BasysArenaComponent]
})
export class BasysArenaModule {}
